exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-btn:disabled{color:#ccc!important;background-color:#f2f2f2!important;border-color:#f2f2f2!important}", ""]);

